import React from 'react';
import { BtnChiTietHopDong } from './BtnChiTietHopDong';
import { BtnChiTietNhanVay } from './BtnChiTietNhanVay';
import { BtnChiTietKhachHang } from './BtnChiTietKhachHang';

export const ContentTable = ({ 
    list, 
    columns, 
    pageIndex, 
    pageSize, 
    onOpenModalHopDong, 
    onOpenModalKhachHang, 
    onOpenModalNhanVay 
}) => {

    const renderCellContent = (col, item) => {
        if (col.isCustomerLink) {
            return (
                <BtnChiTietKhachHang 
                    item={item} 
                    onOpenModalKhachHang={onOpenModalKhachHang} 
                />
            );
        }

        if (col.isContractLink) {
            if (item.ChoVayID) {
                return (
                    <div style={{  alignItems: 'center', gap: '4px' }}>
                        {item.DienGiai && (
                            <span style={{ color: '#5a5c69' }}>
                                {item.DienGiai}.
                            </span>
                        )}
                        <BtnChiTietHopDong 
                            item={item} 
                            onOpenModalHopDong={onOpenModalHopDong} 
                        />
                    </div>
                );
            }
            if (item.NhanVayID) {
                return (
                    <div style={{  alignItems: 'center', gap: '4px' }}>
                        {item.DienGiai && (
                            <span style={{ color: '#5a5c69' }}>
                                {item.DienGiai}.
                            </span>
                        )}
                       <BtnChiTietNhanVay item={item} onOpenModalNhanVay={onOpenModalNhanVay} />
                    </div>   
            );
            }
            
            return item[col.accessor];
        }
        if (col.render) {
            return col.render(item);
        }
        return item[col.accessor];
    };
    
    return (
        <>
            {list.map((item, index) => (
                <div 
                    key={index} 
                    className="custom-table-row" 
                    style={{ 
                        minHeight: "56px", 
                        borderBottom: '1px solid #e0e0e0',
                    }}
                >
                    <div className="custom-table-cell flex-basis-5 " style={{ padding: '5px', fontWeight: 'bold', color: '#858796', display: 'flex', justifyContent: 'center'   }}>
                        <span className="mobile-column-name color7-bold">STT</span>
                        <div className="center-wrapper word-break text-center">
                        {(pageIndex - 1) * pageSize + index + 1}
                        </div>
                    </div>
                    {columns.map((col, colIndex) => {
                        let justifyValue = 'flex-start';
                        if (col.align === 'text-center') justifyValue = 'center';
                        if (col.align === 'text-right') justifyValue = 'flex-end';

                        return (
                            <div 
                                key={colIndex} 
                                className={`custom-table-cell ${col.className}`}
                            >
                                <span className="mobile-column-name color7-bold">{col.header}</span>
                                <div 
                                   className={`center-wrapper word-break ${col.align}`}  
                                     style={{ width: '100%', justifyContent: justifyValue }}
                                >
                                   {renderCellContent(col, item)}
                                </div>
                            </div>
                        );
                    })}
                </div>
            ))} 
        </>
    );
};